import { render, staticRenderFns } from "./CommondityEditIndex.vue?vue&type=template&id=7e155688&scoped=true&"
import script from "./CommondityEditIndex.vue?vue&type=script&lang=js&"
export * from "./CommondityEditIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e155688",
  null
  
)

export default component.exports